module.exports = __webpack_public_path__ + "media/footer/place-43d2cf21.svg";